define([
    "jquery",
    "underscore",
    "marionette",
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'downloadTermsAndConditionsBtn': '.download_terms_and_condition_btn'
        },

        events: {
            'click @ui.downloadTermsAndConditionsBtn': 'downloadTermsAndConditions',
        },

        initialize: function()
        {
            this.bindUIElements();
        },

        downloadTermsAndConditions: function(e)
        {
            e.preventDefault();
            window.open(window.terms_and_conditions_url, '_blank');
        }
    });
});